/**
 * Renders agent-authored markdown (challenge narratives, summaries) at
 * caption scale, with the tool-payload escaping normalized first.
 */
import { Box, SxProps, Theme } from "@mui/material";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { normalizeMultiline } from "./normalizeMultiline";

// Markdown's default block spacing is page-scale; tighten it for panels.
const baseSx: SxProps<Theme> = {
  color: "text.secondary",
  "& p, & ul, & ol": { my: 0.5 },
  "& ul, & ol": { pl: 2 },
  "& h1, & h2, & h3, & h4": {
    fontSize: "1.08em",
    fontWeight: 600,
    mt: 1,
    mb: 0.5,
  },
  "& hr": { my: 1, border: 0, borderTop: "1px solid", borderColor: "divider" },
  "& table": { borderCollapse: "collapse" },
  "& th, & td": { border: "1px solid", borderColor: "divider", px: 0.5 },
};

export const AgentMarkdown = ({
  text,
  sx,
}: {
  text: string;
  sx?: SxProps<Theme>;
}) => (
  <Box sx={{ ...baseSx, ...sx } as SxProps<Theme>}>
    <Markdown remarkPlugins={[remarkGfm]}>{normalizeMultiline(text)}</Markdown>
  </Box>
);
